// The single ApiClient instance for the whole app.
//
// Token & 401 handling are wired through tiny module-level holders so the
// client can stay a stable singleton (created once, never recreated on
// re-render) while still picking up login/logout immediately:
//   - setAuthToken(t)        — AuthProvider calls this whenever the token changes
//   - setOnUnauthorized(cb)  — AuthProvider registers "drop token + go to /login"
//
// In dev, /v1/* is proxied to the Go backend by vite.config.ts; in prod
// the app is served at /app/ on the same origin as /v1/, so baseUrl "" works.

import { createApi } from "@noc/api";

let currentToken: string | null = null;
let onUnauthorizedCb: (() => void) | null = null;

export function setAuthToken(token: string | null): void {
  currentToken = token;
}

export function setOnUnauthorized(cb: (() => void) | null): void {
  onUnauthorizedCb = cb;
}

export const api = createApi({
  baseUrl: "", // same-origin (dev proxy / prod /app/ alias)
  getToken: () => currentToken,
  onUnauthorized: () => onUnauthorizedCb?.(),
});
